import Credit from './Layouts/credit';
import Features from './Layouts/features';
import HeroSection from './Layouts/herosection';
import Ready from './Layouts/ready';

function LandingPage({ user, error }: any) {

  return (
    <div>
      <HeroSection user={user} error={error}/>
      <Features />
      <Ready user={user} error={error}/>
      <Credit />
    </div>
  );
}

export default LandingPage;